/* eslint-disable max-lines */
import { Component, Input } from '@angular/core';
import {
  DynamicBannerConfiguration,
  DynamicBannerContent,
  DynamicBannerStyleProperties
} from '../../../models';

/** This component is responsible to render a specific banner depending on the templateType params */
@Component({
  selector: 'idp-dynamic-banner',
  templateUrl: './dynamic-banner.component.html',
  styleUrls: ['./dynamic-banner.component.scss']
})
export class DynamicBannerComponent {
  /**
   * This props holds all content regarding dynamic image banner
   * which consists of several different types of banner
   */
  @Input() content: DynamicBannerContent = {} as DynamicBannerContent;
  @Input() config: DynamicBannerConfiguration =
    {} as DynamicBannerConfiguration;

  @Input() styles: DynamicBannerStyleProperties =
    {} as DynamicBannerStyleProperties;

  /**  generate classes according to the desktopEnabled and mobileEnabled status */
  getDynamicClass(): string {
    return this.config?.deviceConfig?.desktopEnabled
      ? this.config?.deviceConfig?.mobileEnabled
        ? ''
        : 'banner-d-sm-none banner-d-md-block'
      : this.config?.deviceConfig?.mobileEnabled
      ? 'banner-d-sm-block banner-d-md-none'
      : 'banner-d-none';
  }
}
